import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import SimpleInput from "../../../components/dashboard/common/form/SimpleInput";
import SimpleSelect from "../../../components/dashboard/common/form/SimpleSelect";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import { uploadToS3 } from "../../../functions/uploadToS3";
import { Productfilters } from "../../../mock/DropdownOptions";
import { uploadProduct } from "../../../service/DashboardService";

const categoryOptions =
  Productfilters.find((filter) => filter.id === "subCategory" && filter.name === "Type")
    ?.options || [];

const propertiesOptions =
  Productfilters.find((filter) => filter.id === "properties" && filter.name === "Properties")
    ?.options || [];

const materialOptions =
  Productfilters.find((filter) => filter.id === "materials" && filter.name === "Materials")
    ?.options || [];

const applicationOptions =
  Productfilters.find((filter) => filter.id === "application" && filter.name === "Application")
    ?.options || [];

const certificationOptions =
  Productfilters.find((filter) => filter.id === "Certification" && filter.name === "Certification")
    ?.options || [];

const AddNewProduct = () => {
  const [productData, setProductData] = useState({
    ProductName: "",
    Image1Main: "",
    PdfFile: "",
    Properties: "",
    Application: "",
    Materials: "",
    PrdtCategory: "",
    SubCategory: "",
    Certification:""
  
  });
  const [SubcategoryOptions, setSubcategoryOptions] = useState(
    []
  );

  const [selectedCategory, setSelectedCategory] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const token = localStorage.getItem("accessToken");
      const userId = parseInt(localStorage.getItem("userId"), 10);
  
      const response = await uploadProduct(productData, userId, token);

      if (response) {
        setProductData({
          ProductName: "",
          Image1Main: "",
          PdfFile: "",
          Properties: "",
          Application: "",
          Materials: "",
          selectedCategory: "",
          SubCategory: "",
        
        });
        toast.success("Product Uploaded successfully");
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(error.message || "Something went wrong");
    }
  };

  const handleMainImageUpload = async (event) => {
    const file = event.currentTarget.files[0];
    setProductData({ ...productData, Image1Main: file });
    await uploadToS3(file, setProductData, "Image1Main");
  };


  const handlePdfUpload = async (event) => {
    const file = event.currentTarget.files[0];
    setProductData({ ...productData, PdfFile: file });
    await uploadToS3(file, setProductData, "PdfFile");
  };



  useEffect(() => {
    const selectedCategoryOptions = categoryOptions.find(
      (option) => option.value === selectedCategory
    );

    if (selectedCategoryOptions) {
      setSubcategoryOptions(
        selectedCategoryOptions.subcategories || []
      );
    } else {
      setSubcategoryOptions([]);
    }
  }, [selectedCategory]);

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setProductData({
      ...productData,
      PrdtCategory: event.target.value,
    });
  };



  return (
    <div>
      <TopHeader tabName={"Upload new Product"} />
      <form onSubmit={handleSubmit}>

        <div className=" pb-12">
          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-2">
              <SimpleInput
                type={"text"}
                label={"Product Name"}
                value={productData.ProductName}
                onChange={(e) =>
                  setProductData({
                    ...productData,
                    ProductName: e.target.value,
                  })
                }
                required
              />
            </div>


          </div>
        </div>

        <div className="border-b border-gray-900/10 pb-12">
          <div className=" grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-2">
              <SimpleSelect
                type={"text"}
                title={"Product Category"}
                selectoptions={categoryOptions}
                value={selectedCategory}
                onChange={handleCategoryChange}
                required
              />



            </div>
            <div className="sm:col-span-2">
              <SimpleSelect
                type={"text"}
                title={"Product SubCategory"}
                selectoptions={SubcategoryOptions}
                value={productData.SubCategory}
                onChange={(e) =>
                  setProductData({
                    ...productData,
                    SubCategory: e.target.value,
                  })
                }

                disabled={!selectedCategory}
                required
              />
            </div>
            <div className="sm:col-span-2">
              <SimpleSelect
                type={"text"}
                title={"Properties"}
                selectoptions={propertiesOptions}
                value={productData.Properties}
                onChange={(e) =>
                  setProductData({
                    ...productData,
                    Properties: e.target.value,
                  })
                }
                required
              />
            </div>
            <div className="sm:col-span-2">
              <SimpleSelect
                type={"text"}
                title={"Application"}
                selectoptions={applicationOptions}
                value={productData.Application}
                onChange={(e) =>
                  setProductData({
                    ...productData,
                    Application: e.target.value,
                  })
                }
                required
              />
            </div>

            <div className="sm:col-span-2">
              <SimpleSelect
                type={"text"}
                title={"Materials"}
                selectoptions={materialOptions}
                value={productData.Materials}
                onChange={(e) =>
                  setProductData({
                    ...productData,
                    Materials: e.target.value,
                  })
                }
                required
              />
            </div>

            <div className="sm:col-span-2">
              <SimpleSelect
                type={"text"}
                title={"Certification"}
                selectoptions={certificationOptions}
                value={productData.Certification}
                onChange={(e) =>
                  setProductData({
                    ...productData,
                    Certification: e.target.value,
                  })
                }
                required
              />
            </div>
        

            <div className="col-span-2">
              <label
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                for="multiple_files"
              >
                Upload main image <span className="text-red-500">*</span>
              </label>
              <input
                className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                id="multiple_files"
                type="file"
                multiple
                onChange={handleMainImageUpload}
              />
              <p
                className="mt-1 text-xs text-gray-800 dark:text-gray-300 float-right"
                id="file_input_help"
              >
                {" "}
                .png, .jpg, .jpeg.
              </p>
            </div>

            <div className="sm:col-span-2">
              <label
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                htmlFor="pdf_file"
              >
                Upload Product Specifications <span className="text-red-500">*</span>
              </label>
              <input
                className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                id="pdf_file"
                type="file"
                accept="application/pdf"
                onChange={handlePdfUpload}
              />
              <p
                className="mt-1 text-xs text-gray-800 dark:text-gray-300 float-right"
                id="pdf_file_input_help"
              >
                {" "}
                PDF (MAX. 5MB).
              </p>
            </div>        
          </div>
        </div>
        <div className="mt-6 flex items-center justify-end gap-x-6">
          <button
            type="button"
            className="text-sm font-semibold leading-6 text-gray-900"
          >
            Reset
          </button>
          <button
            type="submit"
            className="flex items-center gap-2 text-gray-900 bg-gradient-to-r from-cyan-200 via-cyan-300 to-cyan-400 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
          >
            Upload
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddNewProduct;
